// extracted by mini-css-extract-plugin
export default {"emptyBox":"EmptyBox_emptyBox__VDT8M","wrapper":"EmptyBox_wrapper__GKgx-","text":"EmptyBox_text__np6zL"};